import { AppHelper } from "../appHelper"
import { AppBaseProps, CommonApp, Context, Entity, Metadata } from "../core/components/commonApp";
import { ServiceReportUtil } from "./serviceReportUtil";
import { Helper } from "../core/util/helper";
import { Commands } from "../core/util/commandManager";
import { NotificationHelper } from "../core/util/notificationHelper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { Config } from "../core/config/config";
import { General } from "../../siteManagement/general";
import { SheetEventType } from "../../siteManagement/sheet";
import { EntityServiceReportTime, ServiceReportTimesInGrid } from "./serviceReportTimesInGrid";
import { EntityServiceReportCashExpenses, ServiceReportCashExpensesInGrid } from "./serviceReportCashExpensesInGrid";
import { EntityServiceReportMaterial, ServiceReportMaterialsInGrid } from "./serviceReportMaterialsInGrid";
import { EntityServiceReportEMailRecipient, ServiceReportEmailsInGrid } from "./serviceReportEmailsInGrid";
import { DialogHelper } from "../core/util/dialogHelper";
import { OpenServiceReportCopiedInfoDialog } from "./serviceReportCopiedInfo";
import { Dialog } from "../core/components/dialog";
import { CheckBox, CheckBoxStatus } from "../core/components/checkBox";
import { ComponentHelper } from "../core/util/componentHelper";
import { FieldInstance } from "../core/components/field";
import { Currency } from "../generalSettings/commercial/dialogs/currencyDialog";
import { EntityServiceReportAccomplishedWork } from "./serviceReportCompletionGrid";
import { StringKeyDictionary } from "../commonInterfaces";
import React from "react";
import ServiceReportOtherTimes from "./serviceReportOtherTimes";
import { Grid } from "../core/components/grid";

export class ServiceReportApp extends React.Component<ServiceReportAppProps, {
    openCopyDialog: boolean;
    copyTimes: boolean;
    copyCashExpenses: boolean;
    copyMaterials: boolean;
    copyDocuments: boolean;
    copyDocumentsCashExpenses: boolean;
}> {
    common = new AppHelper();
    machineGridOptions: {};
    emailRecipientGridOptions: {};
    translations: StringKeyDictionary<string> = null;
    references = {};
    lockId = null;
    //schaltet den Browsertab-Titel an; wird von common aufgerufen
    setTabTitle = true;
    inGridTimesRef: ServiceReportTimesInGrid;
    inGridOtherTimesRef: ServiceReportTimesInGrid;
    inGridCashExpensesRef: ServiceReportCashExpensesInGrid;
    inGridMaterialsRef: ServiceReportMaterialsInGrid;
    inGridEmailsRef: ServiceReportEmailsInGrid;
    timesInGridOptions;
    otherTimesInGridOptions;
    cashExpensesInGridOptions;
    materialsInGridOptions;
    emailsInGridOptions;
    projectResourceGridOptions;
    linkedReportsGridOptions;
    doesAssignmentExits = true;

    constructor(props) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
        this.common.addInGridValidation([
            { gridOptions: this.timesInGridOptions, model: "entity.Times", gridName: Helper.getTranslation("WebSMS.ServiceReport.Zeiten") },
            { gridOptions: this.cashExpensesInGridOptions, model: "entity.CashExpenses", gridName: Helper.getTranslation("WebSMS.ServiceReport.Barauslagen") },
            { gridOptions: this.materialsInGridOptions, model: "entity.Materials", gridName: Helper.getTranslation("WebSMS.ServiceReport.Materialien") },
            { gridOptions: this.emailsInGridOptions, model: "entity.EMailRecipients", gridName: Helper.getTranslation("Field.Adresse.email") }
        ]);
        this.state = {
            openCopyDialog: false,
            copyTimes: Config.settings.serviceReport.copyTimes == 1,
            copyCashExpenses: Config.settings.serviceReport.copyCashExpenses == 1,
            copyMaterials: Config.settings.serviceReport.copyMaterials == 1,
            copyDocuments: Config.settings.serviceReport.copyDocuments == 1,
            copyDocumentsCashExpenses: Config.settings.serviceReport.copyDocumentsCashExpenses == 1
        };
        this.doesAssignmentExits = this.props.doesAssignmentExists;
        this._initApp();
    }

    componentDidMount() {
        this.props.entity.UseDynZeittypen = this.props.dataSources.parentServiceReport.lookups.dynzeittypen.length > 0;
        this.props.entity.SaveTimeShift = Config.user.saveTimeShift;
        this.props.dataSources["currenciesDataSource"] = this.props.entity.ConvertToTargetCurrencies;
    }

    handoverToMobileApp = async () => {
        const valueBefore = this.props.entity.HandoverToMobileApp;
        this.props.entity.HandoverToMobileApp = true;
        if (!await this.saveImplementation(false)) {
            this.props.entity.HandoverToMobileApp = valueBefore;
            this.setState({});
        }
    }

    handoverToMobileClient = async () => {
        const valueBefore = this.props.entity.HandoverToMobileClient;
        this.props.entity.HandoverToMobileClient = true;
        if (!await this.saveImplementation(false)) {
            this.props.entity.HandoverToMobileClient = valueBefore;
            this.setState({});
        }
    }

    handoverToFSM = async () => {
        const isOK = await DialogHelper.confirm(Helper.getTranslation("WebSMS.ServiceReport.UebernahmeInsFSMMsg"));
        if (isOK) {
            const valueBefore = this.props.entity.TakeoverIntoFSM;
            this.props.entity.TakeoverIntoFSM = true;
            if (!await this.saveImplementation(false)) {
                this.props.entity.TakeoverIntoFSM = valueBefore;
                this.setState({});
            }
        }
    }

    enableServiceReport = () => {
        this.props.entity.RecordRight.CanWrite = true;
        this.props.entity.IsTemporaryEditing = true;
        NotificationHelper.showSuccessMessage(Helper.getTranslation("WebSMS.ServiceReport.CanBeEdit"));
        this.setState({});
    }

    complete = async () => {
        const valueBefore = this.props.entity.TakeoverIntoFSM;
        this.props.entity.TakeoverIntoFSM = true;
        if (!await this.saveImplementation(false)) {
            this.props.entity.TakeoverIntoFSM = valueBefore;
            this.setState({});
        }
    }

    release = async () => {
        const valueBefore = this.props.entity.IsReleased;
        this.props.entity.IsReleased = true;
        if (!await this.saveImplementation(false)) {
            this.props.entity.IsReleased = valueBefore;
            this.setState({});
        }
    }

    resetRelease = async () => {
        const valueBefore = this.props.entity.IsReleased;
        this.props.entity.IsReleased = false;
        if (!await this.saveImplementation(false)) {
            this.props.entity.IsReleased = valueBefore;
            this.setState({});
        }
    }

    releaseCommercial = async () => {
        const valueBefore = this.props.entity.IsReleasedCommercial;
        this.props.entity.IsReleasedCommercial = true;
        if (!await this.saveImplementation(false)) {
            this.props.entity.IsReleasedCommercial = valueBefore;
            this.setState({});
        }
    }

    save = (closeAfterSave) => {
        this.saveImplementation(closeAfterSave);
    }

    saveImplementation = async (closeAfterSave): Promise<boolean> => {
        let entity = this.props.entity;
        if (Helper.hasValue(this.inGridTimesRef))
            entity.Times = this.inGridTimesRef.getEntries();
        if (Helper.hasValue(this.inGridOtherTimesRef))
            entity.OtherTimes = this.inGridOtherTimesRef.getGridData();
        if (Helper.hasValue(this.inGridCashExpensesRef))
            entity.CashExpenses = this.inGridCashExpensesRef.getEntries();
        if (Helper.hasValue(this.inGridMaterialsRef))
            entity.Materials = this.inGridMaterialsRef.getEntries();
        if (Helper.hasValue(this.inGridEmailsRef))
            this.props.entity.EMailRecipients = this.inGridEmailsRef.getEntries();
        if (this.common.validate()) {
            const validationResult = ServiceReportUtil.validateAccomplishedWorks(entity.Times, entity.AccomplishedWorks);

            if (!validationResult.valid) {
                NotificationHelper.showErrorMessage(
                    ServiceReportUtil.formatAccomplishedValidationErrorMessage(
                        this.translations["WebSMS.ServiceReport.Validations.AssignableTimes"],
                        validationResult
                    )
                );
            } else {
                const result = await HTTPService.post<JsonResultClass>("ServiceReport/Save", entity)
                if (result.Code == 1) {
                    entity.HandoverToMobileApp = false;
                    entity.HandoverToMobileClient = false;
                    NotificationHelper.showErrorMessage(result.Message);
                } else {
                    await this.reloadData();
                    $(window).trigger("refreshMaschinesGrid", { update: true });
                    if (result.Code === 0) {
                        NotificationHelper.showSuccessMessage(result.Message);
                    } else if (result.Code == 2) {
                        NotificationHelper.showWarningMessage(result.Message);
                    }
                    this.common.setEntityDirtyState(false);
                    this.common.handlePostSave(result.Code === 0, closeAfterSave);
                    return true;
                }
            }
        }
        return false;
    }

    reloadData = async () => {
        const result = await HTTPService.get("ServiceReport/Init/?projNr=" + encodeURIComponent(this.props.entity.Projnr) + "&pIndex=" + encodeURIComponent(this.props.entity.Pindex) + "&id=" + encodeURIComponent(String(this.props.entity.Belegnr)))
        if (result.ErrorCode > 0) {
            NotificationHelper.showErrorMessage(result.Message);
        }
        else {
            Helper.updateEntity(this.props.entity, result.Data);
            this.setLock();
            this.setState({});
        }
    }

    deleteSr = async () => {
        let isOk = await DialogHelper.confirm(Config.translations.deleteMessage);
        if (isOk) {
            let result = await HTTPService.post<JsonResultClass>("ServiceReport/Delete?id=" + encodeURIComponent(this.props.entity.Belegnr));
            if (result.Code == 0) {
                NotificationHelper.showSuccessMessage(result.Message);
                this.common.setEntityDirtyState(false);
                this.closeWindow();
            }
            else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        }
    }

    closeWindow = () => {
        if (this.common.isWindow) {
            this.common.sheetWrapper.trigger(SheetEventType.ItemDeleted, this.props.entity);
            this.common.sheetWrapper.hide();
        } else {
            this.props.entity.RecordRight.CanWrite = false;
            this.setState({});
            setTimeout(() => {
                window.location.href = Config.baseUrl + "DynamicSearch/servicereport";
            }, 1000);
        }
    }

    setLock = () => {
        if (this.lockId === null && this.props.entity.RecordRight.CanWrite && !this.props.entity.IsNew) {
            this.lockId = Helper.keepLockAlive("Lock.ashx", this.props.entity.Belegnr, "LBKOPF", 10000);
        }
    }
    rebookReport = () => {
        let searchType = "Assignment";
        let displayPattern = "[[projnr]]";
        let additionalParams = "";
        let start = kendo.parseDate(this.props.entity.Dvon);
        let end = kendo.parseDate(this.props.entity.Dbis);
        let filterStartSecond = new Date(start.setDate(start.getDate() - 7)).toISOString().slice(0, -14);
        let filterEndSecond = new Date(end.setDate(end.getDate() + 7)).toISOString().slice(0, -14);

        let url = `DynamicSearch/Window/${searchType}?fullObject=true&multi=false&ressnr=${this.props.entity.Ressnr}&startist_start=${filterStartSecond}&startist_end=${filterEndSecond}&displayPattern=${displayPattern}${additionalParams}`;
        const sheet = General.Sheet.Manager.createSheetWithUrl(url, { disableTabTitle: true });
        sheet.bind(SheetEventType.RowClicked, async (data) => {
            let result = await HTTPService.get<JsonResultClass<any>>("ServiceReport/CheckRebookAssignment?id=" + encodeURIComponent(this.props.entity.Belegnr)
                + "&projNr=" + encodeURIComponent(data.projnr) + "&PIndex=" + encodeURIComponent(data.pindex));

            if (result.Data.Machines.length > 0 || result.Data.Materials.length > 0) {

                let msg = "<div style='display: flex; flex-direction: column; row-gap: 5px'>";
                if (result.Data.Materials.length > 0) {
                    msg += `<p>${Helper.getTranslation("ServiceReport.MsgReferencesMaterial")}</p>`;
                }
                if (result.Data.Machines.length > 0) {
                    if (result.Data.Machines.filter(x => x.RefTable != 'LBMASCH').length > 0) {
                        msg += `<p>${Helper.getTranslation("ServiceReport.MsgReferencesMachines")}</P>`
                    }
                    if (result.Data.Machines.filter(x => x.RefTable == 'LBMASCH').length > 0) {
                        msg += `<p>${Helper.getTranslation("ServiceReport.MsgMarkingMachines")}</p>`;
                    }
                }
                msg += "</div>"

                const isOk = await DialogHelper.ask({ text: msg, header: Helper.getTranslation("ServiceReport.ReallyRebook"), isHtml: true, canCancel: true });
                if (!isOk)
                    return;
            }

            HTTPService.post<JsonResultClass>("ServiceReport/ReebookAssignment", { id: this.props.entity.Belegnr, projNr: data.projnr, PIndex: data.pindex }).then(result => {
                if (result.Code == 0) {
                    this.reloadData();
                    NotificationHelper.showSuccessMessage(result.Message);
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
                this.setState({});
                this.common.handlePostSave(result.Code === 0, false);

            });


        }
        );
    }

    copyServiceReport = async () => {
        if (Config.settings.serviceReport.copyTimes == 2
            || Config.settings.serviceReport.copyCashExpenses == 2
            || Config.settings.serviceReport.copyMaterials == 2
            || Config.settings.serviceReport.copyDocuments == 2
            || (Config.settings.serviceReport.copyCashExpenses != 0 && Config.settings.serviceReport.copyDocumentsCashExpenses == 2))
            this.setState({ openCopyDialog: true });
        else
            this.copyServiceReportInternal();
    }

    dynSeachCopyUrl = `DynamicSearch/Window/Assignment_servicereport_copy/?multi=true&displayPattern=[[projnr]]
            &projnr=${encodeURIComponent(this.props.entity.Projnr)}
            &startist_end=${encodeURIComponent(this.props.entity.Dbis)}
            &endeist_start=${encodeURIComponent(this.props.entity.Dvon)}`;

    copyServiceReportInternal = async (copyTimes: boolean = false, copyCashExpenses: boolean = false, copyMaterials: boolean = false, copyDocuments: boolean = false, copyDocumentsCashExpenses: boolean = false) => {
        const sheet = General.Sheet.Manager.createSheetWithUrl(this.dynSeachCopyUrl, null, { disableTabTitle: true });
        sheet.bind(SheetEventType.ItemsSelected, async (data) => {
            let isGuids = data.data.map(x => x.isguid);
            if (!isGuids || isGuids.length == 0) {
                return;
            }

            let result = await HTTPService.post<JsonResultClass<any>>("ServiceReport/Copy", {
                "belegNr": encodeURIComponent(this.props.entity.Belegnr),
                "assignmentGuids": isGuids,
                "settings": {
                    "CopyTimes": copyTimes,
                    "CopyCashExpenses": copyCashExpenses,
                    "CopyMaterials": copyMaterials,
                    "CopyDocuments": copyDocuments,
                    "CopyDocumentsCashExpenses": copyDocumentsCashExpenses
                }
            });
            if (result.Code == 0)
                OpenServiceReportCopiedInfoDialog(result.Data);
            else
                NotificationHelper.showErrorMessage(result.Message);
        })
    }

    distributeExternServiceReportData = async (settings) => {
        let result = await HTTPService.post<JsonResultClass<ServiceReportDistributeInfo>>("ServiceReport/DistributeExternServiceReportData?belegNr=" + encodeURIComponent(this.props.entity.Belegnr), settings);
        if (result.Code == 0) {
            let data = result.Data;
            if (data.NewBelegNrs.length > 0 && data.FailedRessNrs.length == 0)
                NotificationHelper.showSuccessMessage(result.Message);
            else if (data.NewBelegNrs.length == 0 && data.FailedRessNrs.length == 0)
                NotificationHelper.showInfoMessage(Helper.getTranslation("WebSMS.ServiceReportExt.Msg.NoExternData"));
            else {
                let message = data.FailedRessNrs.map(x => Helper.getTranslation("WebSMS.ServiceReportExt.Errors.Distribute")
                    .replace("{0}", data.BelegNr.toString())
                    .replace("{1}", x))
                    .join("</br>");
                DialogHelper.confirm(message, null, null, null, false);
            }
            this.reloadData();
        }
        else
            NotificationHelper.showErrorMessage(result.Message);
    }

    releaseLock = () => {
        if (this.lockId !== null) {
            clearInterval(this.lockId);
            Helper.releaseLock(this.props.entity.Belegnr, "LBKOPF");
            this.lockId = null;
        }
    }

    openAssignment = () => {
        General.Sheet.Manager.createSheetWithUrl(`ResourcePlanning/Edit/?projNr=${this.props.entity.Projnr}&pIndex=${this.props.entity.Pindex}`);

    }
    openProject = () => {
        let sheet = General.Sheet.Manager.createSheetWithUrl('Project/Edit/?id=' + this.props.entity.Projnr);
    }
    private _initApp = () => {
        if (this.props.entity.IsNew) {
            this.common.setEntityDirtyState(true);
            this.common.unloadHelper.markEntitySaved();
        }

        var that = this;

        if (this.props.entity.RecordRight.CanWrite) {
            this.common.unloadHelper.addBeforeUnloadCallback(function () {
                that.releaseLock();
            });
        }

        this.props.context.references = this.references;
        this.props.context.onHandlePostSave = this.common.handlePostSave;
        this.props.context.onEvalAction = this.common.evalAction;
        this.props.context.metadataCompletion = this.props.metadataCompletion;
        this.props.context.machineGrid = this.machineGridOptions;
        this.props.context.emailRecipientGrid = this.emailRecipientGridOptions;
        this.setLock();

        HTTPService.get("ServiceReportLookup/GetContacts?adrNr=" + encodeURIComponent(this.props.entity.Adrnr) + "&projNr=" + encodeURIComponent(this.props.entity.Projnr))
            .then(result => {
                Helper.setArrayValues(that.props.dataSources.dsContacts, result);
                that.common.commandManager.runCommand("entity.ContactPersonPos", Commands.RELOADDATASOURCE);
            });
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    onChange = () => {
        this.common.setEntityDirtyState(true);
    }

    createTimesInGrid = (defaultFieldProps: any) => {
        return <ServiceReportTimesInGrid
            entity={this.props.entity}
            data={this.props.entity.Times}
            gridOptions={this.timesInGridOptions}
            dataSources={this.props.dataSources}
            helpEditUrl={defaultFieldProps.helpUrl}
            ref={(ref) => this.inGridTimesRef = ref}
            onChange={this.onChange} id={""} />;
    }

    createCashExpensesInGrid = (defaultFieldProps: any) => {
        return <ServiceReportCashExpensesInGrid
            entity={this.props.entity}
            data={this.props.entity.CashExpenses}
            gridOptions={this.cashExpensesInGridOptions}
            dataSources={this.props.dataSources}
            translations={this.translations}
            ref={(ref) => this.inGridCashExpensesRef = ref}
            onChange={this.onChange} helpEditUrl={defaultFieldProps.helpUrl} id={""} />;
    }

    createMaterialsInGrid = (defaultFieldProps: any) => {
        return <ServiceReportMaterialsInGrid
            entity={this.props.entity}
            data={this.props.entity.Materials}
            gridOptions={this.materialsInGridOptions}
            dataSources={this.props.dataSources}
            translations={this.translations}
            ref={(ref) => this.inGridMaterialsRef = ref}
            onChange={this.onChange} helpEditUrl={defaultFieldProps.helpUrl} id={""} />;
    }

    createEmailGrid = (defaultFieldProps: any) => {
        return <ServiceReportEmailsInGrid
            entity={this.props.entity}
            data={this.props.entity.EMailRecipients}
            gridOptions={this.emailsInGridOptions}
            dataSources={this.props.dataSources}
            translations={this.translations}
            ref={(ref) => this.inGridEmailsRef = ref}
            onChange={this.onChange} id={""} helpEditUrl={defaultFieldProps.helpUrl} />;
    }

    createOtherTimes = () => {
        let props = Object.assign({}, this.props,
            {
                projectResourceGridOptions: this.projectResourceGridOptions,
                otherTimesInGridOptions: this.otherTimesInGridOptions,
                inGridOtherTimesRef: (ref) => { this.inGridOtherTimesRef = ref }
            });
        return <ServiceReportOtherTimes {...props} />
    }

    createLinkedReports = () => {
        return <Grid
            id="srLinkedReports"
            data={this.props.entity.LinkedReports}
            options={this.linkedReportsGridOptions}
        />
    }

    serviceReportIndividualDataProps = () => {
        return { readonly: this.props.entity.RecordRight.IsRueckModusReadOnly || this.props.entity.RecordRight.IsRueckModusAdded }
    }

    private dialogProps = {
        title: Helper.getTranslation("ServiceReport.CopyServiceReport"),
        afterClose: () => {
            this.setState({ openCopyDialog: false });
        },
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    this.copyServiceReportInternal(this.state.copyTimes, this.state.copyCashExpenses, this.state.copyMaterials, this.state.copyDocuments, this.state.copyDocumentsCashExpenses);
                },
                primary: true
            },
        ]
    };

    render() {
        this.props.entity.SummaryHours = ServiceReportUtil.calculateSummaryHours(this.props.entity.Times);
        this.props.entity.SummaryCashExpenses = ServiceReportUtil.calculateSummaryCashExpenses(this.props.entity.CashExpenses);
        this.props.entity.SummaryMaterials = ServiceReportUtil.calculateSummaryMaterials(this.props.entity.Materials);
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { apphelper: this.common, handleFieldChange: this.handleFieldChange });

        return <>
            <Dialog {...this.dialogProps} open={this.state.openCopyDialog}>
                <DialogCheckBox
                    name={Helper.getTranslation("ServiceReport.CopyServiceReport.CopyTimes")}
                    value={this.state.copyTimes}
                    onChange={(value) => this.setState({ copyTimes: value })}
                    disabled={Config.settings.serviceReport.copyTimes != 2} />
                <DialogCheckBox
                    name={Helper.getTranslation("ServiceReport.CopyServiceReport.CopyCashExpenses")}
                    value={this.state.copyCashExpenses}
                    onChange={(value) => this.setState({ copyCashExpenses: value })}
                    disabled={Config.settings.serviceReport.copyCashExpenses != 2} />
                <DialogCheckBox
                    name={Helper.getTranslation("ServiceReport.CopyServiceReport.CopyMaterials")}
                    value={this.state.copyMaterials}
                    onChange={(value) => this.setState({ copyMaterials: value })}
                    disabled={Config.settings.serviceReport.copyMaterials != 2} />
                <DialogCheckBox
                    name={Helper.getTranslation("ServiceReport.CopyServiceReport.CopyDocuments")}
                    value={this.state.copyDocuments}
                    onChange={(value) => this.setState({ copyDocuments: value })}
                    disabled={Config.settings.serviceReport.copyDocuments != 2} />
                <DialogCheckBox
                    name={Helper.getTranslation("ServiceReport.CopyServiceReport.CopyCashExpensesDocuments")}
                    value={this.state.copyDocumentsCashExpenses}
                    onChange={(value) => this.setState({ copyDocumentsCashExpenses: value })}
                    disabled={Config.settings.serviceReport.copyDocumentsCashExpenses != 2} />
            </Dialog>
            <CommonApp {...props} titleProps={{ followed: this.props.entity.IsWatched, title: this.props.title }} />
        </>;
    }
};

class DialogCheckBox extends React.Component<{
    name: string;
    value: boolean;
    onChange: (value) => void;
    disabled: boolean;
}, any> {
    render() {
        let props = ComponentHelper.createFactory().getDefaultCheckBoxProps();
        props.field.labelAndControlCombined = true;
        props.field.name = this.props.name;
        props.value = this.props.value;

        if (this.props.disabled)
            return <CheckBoxStatus {...props} />

        return <CheckBox
            {...props}
            onChange={(_, value) => this.props.onChange(value)} />
    }
}

interface ServiceReportDistributeInfo {
    BelegNr?: number;
    NewBelegNrs?: number[];
    FailedRessNrs?: string[];
}

export interface ServiceReportAppProps extends AppBaseProps {
    entity: EntityServiceReport;
    context: ContextServiceReport;
    metadataCompletion: Metadata;
    doesAssignmentExists: boolean;
}
export interface ContextServiceReport extends Context {
    machineGrid: {};
    emailRecipientGrid: {};
    references: any;
    onHandlePostSave: any;
    onEvalAction: any;
    metadataCompletion: Metadata;
}

export interface EntityServiceReport extends Entity {
    Belegnr: number;
    Projnr: string;
    Pindex: number;
    Adrnr: string;
    Ressnr: string;
    Dvon: string;
    Dbis: string;
    HandoverToMobileApp: boolean;
    HandoverToMobileClient: boolean;
    TakeoverIntoFSM?: boolean;
    IsTemporaryEditing?: boolean;
    IsCompleted?: boolean;
    IsReleased?: boolean;
    IsReleasedCommercial?: boolean;
    Times: Array<EntityServiceReportTime>;
    OtherTimes?: Array<any>;
    CashExpenses: Array<EntityServiceReportCashExpenses>;
    Materials: Array<EntityServiceReportMaterial>;
    AccomplishedWorks: Array<EntityServiceReportAccomplishedWork>;
    EMailRecipients: Array<EntityServiceReportEMailRecipient>;
    LinkedReports: Array<any>;
    DatesNotInRange: boolean;
    MinStart: string;
    MaxEnd: string;
    UseDynZeittypen?: boolean;
    SaveTimeShift?: boolean;
    RueckreiseModusActivated?: boolean;
    GlobalCurrInt?: string;
    ShowUnit?: boolean;
    Unit?: string;
    DefaultCurrency: Currency;
    TargetCurrency: Currency;
    ConvertToTargetCurrencies: Currency[];
    IdCurr: number;
    IdBaraus: number;
    StatusF?: number;
    HasExternTimes?: boolean;
    SummaryHours: {
        WorkingHours: number, TravelHours: number, WaitingHours: number
    };
    SummaryCashExpenses: {
        Count: number, Sum: number
    };
    SummaryMaterials: {
        Count: number, Sum: number
    }
    RecordRight: {
        CanRead: boolean;
        CanWrite: boolean;
        CanTechnicalRelease?: boolean;
        CanResetTechnicalRelease?: boolean;
        CanCommercialRelease?: boolean;
        IsRueckModusReadOnly?: boolean;
        IsRueckModusAdded?: boolean;
        IsRueckModusCompletellyOpen: boolean;
        RechtRechnungSchreiben?: boolean;
        CanDelete?: boolean;
        CanRebook?: boolean;
        CanHandoverToMobileClient?: boolean;
        CanHandoverToMobileApp?: boolean;
        CanTakeoverIntoFSM?: boolean;
        CanComplete?: boolean;
    }
}